import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import RegisterRentalLayer from '../components/RegisterRentalLayer'

const RegisterRentalPage = () => {
  return (
    <MasterLayout>
        <Breadcrumb title='Register Rental' />
        <RegisterRentalLayer />
    </MasterLayout>
  )
}

export default RegisterRentalPage

